export default "__VITE_ASSET__BBRmecVN__"